<!-- Simple layout container with a fixed header and an optional fixed footer. The content is scrollable -->
<!-- The layout container itself fills the containing outer div -->
<template>
  <div class="layout-container">

    <div :class="`op-header ${$slots['header-row-2']?'two-rows':'one-row'}`">
      <div class="header-row-1">
        <slot name="header-row-1"/>
      </div>
      <div v-if="$slots['header-row-2']"
           class="header-row-2">
        <slot name="header-row-2"/>
      </div>
    </div>

    <!-- Separates header and content. selectedListItemColor is defined in ui-config in themes.light.colors and themes.dark.colors -->
    <div :class="`header-divider-${$slots['header-row-2']?'two-rows':'one-row'} selectedListItemColor`"></div>

    <div :class="`content ${$slots['header-row-2']?'with-two-rows-header':'with-one-row-header'}`"
         :style="`bottom:${$slots['footer']?'38px':'0'}`">
      <slot name="content"></slot>
    </div>
    <slot v-if="$slots['footer']"
          :class="`footer ${theme.elements.headerBg}`"
          name="footer"/>
  </div>

</template>

<script>
export default {
  name: 'LayoutContainer',
};
</script>

<style scoped>
.layout-container {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: hidden;
  border-right: 1px solid #d0d0d0
}

.theme--dark .layout-container {
  border-right: 1px solid #404040;
  background:#202020
}

.theme--light .layout-container {
  background:white
}
.theme--dark .header {
  background:#252525
}

.theme--light .header {
  background:#f5f5f5
}


.header {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;

}

.two-rows {
  height: calc(var(--header-row1-height) + var(--header-row2-height) + 10px);
}

.one-row {
  height: var(--header-row1-height);
}

.layout-container {
  --header-row1-height: 43px;
  --header-row2-height: 32px;
}

.header-row-1,
.header-row-2 {
  position: absolute;
  left: 0;
  right: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.65rem !important;
  font-weight: 300;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 1px;
}

.header-row-1 {
  height: var(--header-row1-height);
}

.header-row-2 {
  top: var(--header-row1-height);
  height: var(--header-row2-height);
  bottom: 0;
}

.header-divider-one-row,
.header-divider-two-rows {
  position: absolute;

  height: 1px;
  left: 0;
  right: 0;
}

.header-divider-one-row {
  top: var(--header-row1-height);
}

.header-divider-two-rows {
  top: calc(var(--header-row1-height) + var(--header-row1-height));
}

.footer {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 37px;
  display: flex;
  align-items: center !important;
  justify-content: center;
  z-index: 100;
}

.content {
  position: absolute;
  left: 0;

  right: 0;
}

.content.with-two-rows-header {
  top: calc(var(--header-row1-height) + var(--header-row2-height) + 10px);
}

.content.with-one-row-header {
  top: var(--header-row1-height);
}

.content {
  overflow-y: scroll;
}

.content::-webkit-scrollbar,
::-webkit-scrollbar {
  display: none;
}

* {
  scrollbar-width: none;
  /* Firefox */
}

.content {
  -ms-overflow-style: none !important;
  /* IE 11 */
  scrollbar-width: none !important;
  /* Firefox 64 */
}
</style>